import { createSelector } from 'reselect';
import { ClientReducerState } from 'client/reducers';
import { selectCardId } from 'client/reducers/card/selectors';
import { StoryFacade } from 'common/utils';

export const selectStory = (state: ClientReducerState) => state.story;

export const selectStorySettings = createSelector(
	selectStory,
	story => story.storyVersions?.[StoryFacade.VERSIONS.latest].settings
);

export const selectStoryCardSettings = createSelector(
	[selectStorySettings, (state: ClientReducerState, cardId?: string) => cardId ?? selectCardId(state)],
	(storySettings, cardId) =>
		storySettings !== undefined && cardId !== undefined ? storySettings.cards?.[cardId] : undefined
);
